import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Button } from '@material-ui/core';
import Description from '@material-ui/icons/Description';
import IconCancel from '@material-ui/icons/Cancel';

const TruncatedArrayDisplay = ({
  items = [],
  maxItems = 12,
  label = 'Items',
  emptyMessage = 'No items available',
  itemRenderer = (item) => item,
  showNumbers = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  if (!items || items.length === 0) {
    return <div style={{ fontSize: '12px', fontStyle: 'italic' }}>{emptyMessage}</div>;
  }

  const displayItems = items.slice(0, maxItems);
  const hasMoreItems = items.length > maxItems;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
      <div>
        <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
          {label} ({items.length}):
        </div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          {displayItems.map(itemRenderer).join(', ')}
          {hasMoreItems && '...'}
        </div>
      </div>

      {hasMoreItems && (
        <div style={{ transform: 'scale(0.8)' }}>
          <IconButton onClick={handleOpenModal} size="small">
            <Description />
          </IconButton>
        </div>
      )}

      <Dialog open={isOpen} onClick={(e) => e.stopPropagation()}>
        <DialogTitle>
          All {label} ({items.length})
        </DialogTitle>
        <DialogContent>
          <div style={{ maxHeight: '400px', overflow: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                    {showNumbers && (
                      <td
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          color: '#333',
                          verticalAlign: 'top',
                          width: '40px',
                        }}
                      >
                        {index + 1}
                      </td>
                    )}
                    <td style={{ padding: '4px 8px', fontSize: '12px', color: '#333' }}>{itemRenderer(item)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            <IconCancel style={{ marginRight: '5px' }} />
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TruncatedArrayDisplay;
